import { render, staticRenderFns } from "./ContactCompanyForm.vue?vue&type=template&id=904e6976"
import script from "./ContactCompanyForm.vue?vue&type=script&lang=js"
export * from "./ContactCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports